import { Button, DropdownMenu, lucideIcons } from '@round/creatorbase-ui';

const { EllipsisVertical, Trash2 } = lucideIcons;

type Props = {
    onDelete: () => void;
};

// DropdownMenu.Content is portaled, so a click on "Delete" reaches the row's
// onRowClick via React's tree-based event bubbling even though it's outside
// the row in the DOM. Stop it here rather than also navigating on delete.
export const ActionsCell = ({ onDelete }: Props) => {
    return (
        <div onClick={(e) => e.stopPropagation()}>
            <DropdownMenu>
                <DropdownMenu.Trigger asChild>
                    <Button type="button" variant="ghost" size="icon-sm" aria-label="Actions">
                        <EllipsisVertical />
                    </Button>
                </DropdownMenu.Trigger>
                <DropdownMenu.Content align="end">
                    <DropdownMenu.Item variant="destructive" onSelect={onDelete}>
                        <Trash2 />
                        Delete
                    </DropdownMenu.Item>
                </DropdownMenu.Content>
            </DropdownMenu>
        </div>
    );
};
